import { defineComponent, PropType } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapState } from "pinia";

import { useApp } from "../../../../App/useApp";
import { useConversationStore } from "../../../store/useConversationStore";
import type { IMessageItem } from "../../../../../resources-vue/vue-interfaces/messaging-service/i-message";
import { formatUserInitials } from "../../../../../common/vue-helpers/modifiers/format-message";
import { MessageService } from "../../../../../services/message-service";
import { ToastrService } from "../../../../../services/toastr.service";
import { getSolutionClassIndex } from "../../../../../common/vue-helpers/solution-color-index";
import EmojiPicker from "../../../../../resources-vue/vue-custom-elements/EmojiPicker/EmojiPicker.vue";

export default defineComponent({
    props: {
        message: {
            type: Object as PropType<IMessageItem>,
            default: {} as IMessageItem
        }
    },
    components: { EmojiPicker },

    data() {
        return {
            formatUserInitials,
            getSolutionClassIndex,
            _messageService: null as MessageService,
            _toastrService: null as ToastrService,
            userOs: "" as string
        };
    },

    created() {
        this.userOs = window.sessionStorage.getItem("userOs");
        this._messageService = Container.instance.get(MessageService);
        this._toastrService = Container.instance.get(ToastrService);
    },

    computed: {
        ...mapState(useApp, ["loggedInUserDetails"]),
        ...mapState(useConversationStore, ["activeConversationId"]),

        totalReactions(): number {
            if (!this.message?.messageReactions) return 0;
            return Object.keys(this.message.messageReactions).length;
        },

        visibleReactions(): Record<string, any[]> {
            return Object.fromEntries(Object.entries(this.message.messageReactions).slice(0, 4));
        },

        extraReactions(): Record<string, any[]> {
            if (this.totalReactions <= 4) return {};
            return Object.fromEntries(Object.entries(this.message.messageReactions).slice(4));
        },

        extraReactionsCount(): number {
            return this.totalReactions > 4 ? this.totalReactions - 4 : 0;
        }
    },

    methods: {
        async handleEmoji(emoji: string) {
            if (!this.message) return;
            try {
                await this._messageService.sendReaction(this.message.id, this.activeConversationId, emoji);
            } catch (error) {
                console.error(error);
                this._toastrService.error({
                    title: `Error - Failed`,
                    message: `Failed to send reaction. Please try again.`
                });
            }
        }
    }
});
